import * as Sfx from "redux-saga/effects";
import {
    getStatistics,
    OPEN_SPORT_STATISTICS,
    CLOSE_SPORT_STATISTICS,
} from "@atg-sport-shared/sportsbook-data-access-statistics";
import {getSportFromEventId} from "@atg-sport-shared/sportsbook-data-access-event";
import {
    sportStatsOpen,
    sportStatsClose,
} from "@atg-sport-shared/sportsbook-utils-analytics";

const getDuration = (start: number) =>
    Math.ceil(((Date.now() - start) / 1000 + 1) / 10) * 10;

function* statisticsAnalytics(): Generator<Sfx.Effect, void, any> {
    const start = Date.now();
    const {eventId, origin} = yield Sfx.select(getStatistics);
    const sport = yield Sfx.select(getSportFromEventId, eventId);

    yield Sfx.call(sportStatsOpen, eventId, sport, origin);
    yield Sfx.take(CLOSE_SPORT_STATISTICS);
    yield Sfx.call(sportStatsClose, eventId, sport, getDuration(start));
}

export function* analyticsSaga(): Generator<Sfx.Effect, void, any> {
    yield Sfx.takeLeading(OPEN_SPORT_STATISTICS, statisticsAnalytics);
}
